<template>
  <Modal modalId="account-needs-attention" size="modal-md">
    <ModalHeader
      :title="$t('xYourAccountNeedsAttentionHeader')"
      icon="far fa-exclamation-triangle"
      :style="{ padding: '10px 10px 10px 10px' }"
    >
      <div class="cols-auto">
        <button
          type="button"
          class="btn btn-icon-button btn-icon-button--gray"
          @click="closeModal('account-needs-attention')"
        >
          <i class="fas fa-times" />
        </button>
      </div>
    </ModalHeader>
    <ModalBody>
      <div class="row">
        <div class="col">
          {{ $t('xHomePremiumLimitText') }}
        </div>
      </div>
    </ModalBody>
    <ModalFooter>
      <button type="button" @click="navToSupportPage()" class="btn btn-primary">
        {{ $t('xContactSupportUpgrade') }}
      </button>
    </ModalFooter>
  </Modal>
</template>

<script>
export default {
  methods: {
    navToSupportPage() {
      this.$appInsights.trackEvent({
        name: 'click-contact-support-settings-subscription-modal',
        properties: {}
      })
      this.$router.push({
        path: `/support`
      })
    }
  }
}
</script>
